import React, { useMemo } from 'react';
import { Grid, Row, Col } from 'rsuite';
import PaymentSummary from './PaymentSummary';
import PaymentMethodSelector from '../PaymentMethodSelector';
import { PaymentForm } from './PaymentForm';
import { useSelector } from 'react-redux';
import { selectPaymentID, selectPaymentSignatory, selectSelectedPaymentMethod, selectPaymentFees } from '../../../../store/slices/payment/paymentSelectors';
import { selectConfigSettings } from '../../../../store/slices/config/configSelectors';
import { selectCurrentUserEmail } from '../../../../store/slices/auth/authSelectors';
import IconIndicator from '../../../user-feedback/IconIndicator';

export const Payment = ({ flow, onSuccess, permitIdentifier }) => {
  const paymentMethod = useSelector(selectSelectedPaymentMethod);
  const settings = useSelector(selectConfigSettings);
  const cityName = settings.placeDisplayName;
  const provider = settings.paymentProcessor;
  const userEmail = useSelector(selectCurrentUserEmail);
  const signatoryName = useSelector(selectPaymentSignatory);
  const paymentID = useSelector(selectPaymentID);
  const paymentFees = useSelector(selectPaymentFees);

  const hasData = useMemo(() => {
    return cityName && userEmail && signatoryName && paymentID && paymentMethod;
  }, [cityName, userEmail, signatoryName, paymentID, paymentMethod]);

  return (
    <Grid fluid>
      <Row>
        <Col
          xs={24}
          lg={8}
        >
          <PaymentSummary />
        </Col>
        <Col
          xs={24}
          lg={16}
        >
          <Grid fluid>
            <Row className="mb-20">
              <Col xs={24}>
                <PaymentMethodSelector />
              </Col>
            </Row>
            {hasData && (
              <PaymentForm
                onSuccess={onSuccess}
                provider={provider}
                paymentMethod={paymentMethod}
                city={cityName}
                flow={flow}
                paymentID={paymentID}
                signatoryName={signatoryName}
                userEmail={userEmail}
                fees={paymentFees}
                permitIdentifier={permitIdentifier}
              />
            )}
            {!hasData && <IconIndicator />}
          </Grid>
        </Col>
      </Row>
    </Grid>
  );
};

export default Payment;
